import { Component, Inject } from '@angular/core';
import { StatusTenantDialogComponent } from '../status-tenant-dialog/status-tenant-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'adp-select-company',
  templateUrl: './select-company.component.html',
  styleUrl: './select-company.component.scss'
})
export class SelectCompanyComponent {
  filteredTenants: any[] = [];
  selectedTenant: string = '';
  tenantSearchCtrl = new FormControl('');

  constructor(
    private dialogRef: MatDialogRef<StatusTenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.filteredTenants = [...data.tenants];

    // Filtrado por búsqueda
    this.tenantSearchCtrl.valueChanges
      .pipe(debounceTime(200))
      .subscribe(search => this.filterTenants(search));
    // console.log(this.filteredTenants);
      
  }

  filterTenants(search: string): void {
    if (!search) {
      this.filteredTenants = [...this.data.tenants];
      return;
    }

    const searchValue = search.toLowerCase();
    this.filteredTenants = this.data.tenants.filter(t =>
      t.name.toLowerCase().includes(searchValue)
    );
  }

  confirm(): void {
    this.dialogRef.close(this.selectedTenant);
  }
}
